// extracted by mini-css-extract-plugin
module.exports = {"swiper":"Swiper_swiper__BSfEE","swiperClass":"Swiper_swiperClass__ofYVI"};